// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"cad37728","158":"250530df"}[chunkId] + ".chunk.css";
};